
import TheGraph from "../../../assets/duotone/TheGraph.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TheGraphIcon({ className, dataTestid = "TheGraphIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TheGraph data-testid={dataTestid} className={classes} {...rest} />
  );
}
